import { Instagram, Music2 } from "lucide-react";
import { IMAGES } from "@/lib/site";
import { Reveal } from "@/components/Reveal";
import { GoldDivider } from "@/components/GoldDivider";
import { useLang } from "@/i18n";

const TILES = [
    { src: IMAGES.tarot, alt: "Cartas de tarot a la luz de las velas" },
    { src: IMAGES.runes, alt: "Piedras rúnicas talladas" },
    { src: IMAGES.lantern, alt: "Lámpara ornamental iluminada" },
    { src: IMAGES.crystalBall, alt: "Bola de cristal en ambiente místico" },
    { src: IMAGES.buddha, alt: "Buda dorado entre velas" },
    { src: IMAGES.candles, alt: "Velas encendidas con hierbas" },
];

export const Social = () => {
    const { t } = useLang();

    return (
        <section id="contacto" data-testid="social-section" className="relative py-24 sm:py-32 px-5 sm:px-8 bg-ink">
            <div className="max-w-5xl mx-auto text-center">
                <Reveal>
                    <p className="font-accent text-[11px] tracking-[0.4em] uppercase text-gold-soft mb-4">
                        {t("social.eyebrow")}
                    </p>
                    <h2 className="font-display font-semibold gold-text text-4xl sm:text-5xl tracking-wide">
                        {t("social.title")}
                    </h2>
                    <GoldDivider className="my-8" />
                    <div className="flex flex-wrap items-center justify-center gap-4">
                        <a
                            href="https://www.instagram.com/eljardin_devenuz"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="social-instagram-link"
                            className="inline-flex items-center gap-2.5 border border-gold/45 text-gold font-accent text-[10px] tracking-[0.2em] uppercase px-6 py-3 rounded-sm hover:bg-gold/10 hover:shadow-[0_0_18px_rgba(212,175,55,0.2)] hover:-translate-y-0.5 transition-[background-color,box-shadow,transform] duration-300"
                        >
                            <Instagram className="w-4 h-4" /> Instagram
                        </a>
                        <a
                            href="https://www.tiktok.com/@eljardindelossecretos"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="social-tiktok-link"
                            className="inline-flex items-center gap-2.5 border border-gold/45 text-gold font-accent text-[10px] tracking-[0.2em] uppercase px-6 py-3 rounded-sm hover:bg-gold/10 hover:shadow-[0_0_18px_rgba(212,175,55,0.2)] hover:-translate-y-0.5 transition-[background-color,box-shadow,transform] duration-300"
                        >
                            <Music2 className="w-4 h-4" /> TikTok
                        </a>
                    </div>
                </Reveal>

                <div className="grid grid-cols-3 sm:grid-cols-6 gap-3 mt-12" data-testid="social-grid">
                    {TILES.map((tile, i) => (
                        <Reveal key={i} delay={i * 0.05}>
                            <div className="group relative aspect-square overflow-hidden bg-surface border border-gold/15 rounded-sm hover:border-gold/40 hover:shadow-[0_0_18px_rgba(212,175,55,0.15)] transition-[border-color,box-shadow] duration-300">
                                <img
                                    src={tile.src}
                                    alt={tile.alt}
                                    loading="lazy"
                                    className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-[opacity,transform] duration-500"
                                />
                                <span className="absolute inset-0 flex items-center justify-center bg-ink/45 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                    <Instagram className="w-5 h-5 text-gold" />
                                </span>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};
